import * as Types from '../../__generated__/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteContactFormConsentMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  consentId: Types.Scalars['ID']['input'];
}>;


export type DeleteContactFormConsentMutation = { __typename?: 'RootMutationType', deleteContactFormConsent: { __typename?: 'ActionResult', userErrors?: Array<{ __typename?: 'UserError', field: string, message: string }> | null } };


export const DeleteContactFormConsentDocument = gql`
    mutation deleteContactFormConsent($id: ID!, $consentId: ID!) {
  deleteContactFormConsent(id: $id, consentId: $consentId) {
    userErrors {
      field
      message
    }
  }
}
    `;
export type DeleteContactFormConsentMutationFn = Apollo.MutationFunction<DeleteContactFormConsentMutation, DeleteContactFormConsentMutationVariables>;

/**
 * __useDeleteContactFormConsentMutation__
 *
 * To run a mutation, you first call `useDeleteContactFormConsentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContactFormConsentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContactFormConsentMutation, { data, loading, error }] = useDeleteContactFormConsentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      consentId: // value for 'consentId'
 *   },
 * });
 */
export function useDeleteContactFormConsentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContactFormConsentMutation, DeleteContactFormConsentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContactFormConsentMutation, DeleteContactFormConsentMutationVariables>(DeleteContactFormConsentDocument, options);
      }
export type DeleteContactFormConsentMutationHookResult = ReturnType<typeof useDeleteContactFormConsentMutation>;
export type DeleteContactFormConsentMutationResult = Apollo.MutationResult<DeleteContactFormConsentMutation>;
export type DeleteContactFormConsentMutationOptions = Apollo.BaseMutationOptions<DeleteContactFormConsentMutation, DeleteContactFormConsentMutationVariables>;